import { Link } from "react-router-dom";
import imagePlaceHolder from "../../assets/No-Image-Placeholder.png";
import { AgentName } from "../../config/config";

const ProductCard = ({ itemName, searchName, price, productId }) => {



  const imagePath = `/images/${productId}.webp`;

  return (
    <Link
      to={`/products/${encodeURIComponent(searchName)}/${productId}`}
      target="_blank"
      rel="noopener noreferrer"
      className="block transition-transform transform hover:scale-105"
    >
      <div className="shadow-md hover:shadow-lg rounded-lg overflow-hidden flex flex-col h-full bg-white">
        <div className="w-full h-48 overflow-hidden">
          <img
            src={imagePath}
            onError={(e) => { e.target.onerror = null; e.target.src = imagePlaceHolder }}
            alt={`${AgentName} Spreadsheet ${itemName}`}
            loading="lazy"
            title={`${AgentName} Spreadsheet ${itemName}`}
            width={192}
            height={192}
            className="w-96 h-48  mb-4 rounded"
          />
        </div>

        <div className="flex flex-col flex-1 p-4 justify-between">
          <div>
            <h2 className="text-lg font-semibold text-gray-900 truncate">{itemName}</h2>
            <p className="text-sm text-gray-700 mt-1">${price}</p>
          </div>

        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
